import React, {useState, useEffect, Fragment} from 'react';
import 'fontsource-roboto';
import {makeStyles} from '@material-ui/core/styles';
import useIsMountedRef from './../Components/useIsMountedRef';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

import Warning from '../Components/Warning';

const useStyles = makeStyles(theme => ({
  errorMain: {
    color: theme.palette.error.contrastText,
    backgroundColor: theme.palette.error.main
  },
  errorLight: {
    color: theme.palette.error.contrastText,
    backgroundColor: theme.palette.error.light
  },
  errorDark: {
    color: theme.palette.error.contrastText,
    backgroundColor: theme.palette.error.dark
  },
  warningMain: {
    color: theme.palette.warning.contrastText,
    backgroundColor: theme.palette.warning.main
  },
  warningLight: {
    color: theme.palette.warning.contrastText,
    backgroundColor: theme.palette.warning.light
  },
  warningDark: {
    color: theme.palette.warning.contrastText,
    backgroundColor: theme.palette.warning.dark
  },
  infoMain: {
    color: theme.palette.info.contrastText,
    backgroundColor: theme.palette.info.main
  },
  infoLight: {
    color: theme.palette.info.contrastText,
    backgroundColor: theme.palette.info.light
  },
  infoDark: {
    color: theme.palette.info.contrastText,
    backgroundColor: theme.palette.info.dark
  },
  successMain: {
    color: theme.palette.success.contrastText,
    backgroundColor: theme.palette.success.main
  },
  successLight: {
    color: theme.palette.success.contrastText,
    backgroundColor: theme.palette.success.light
  },
  successDark: {
    color: theme.palette.success.contrastText,
    backgroundColor: theme.palette.success.dark
  },
  divider: {
    margin: theme.spacing(.5, 0)
  },
  link: {
    textDecoration: 'initial',
    color: 'inherit',
    '&:active': {
      color: 'inherit'
    }
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    margin: theme.spacing(0.5)
  },
  cardHeader: {
    padding: theme.spacing(1, 2, 1)
  },
  cardContent: {
    flexGrow: 1,
    padding: theme.spacing(1),
    '&:last-child': {
      paddingBottom: theme.spacing(1)
    }
  },
  fab: {
    position: 'fixed',
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  }
}));

export default function ViewReception(props) {
  const classes = useStyles();
  const ajax = props.ajax;

  const isMountedRef = useIsMountedRef();

  const [isLoaded, setIsLoaded] = useState(false);
  const [data, setData] = useState({
    id: '',
    surname: '',
    name: '',
    cnp: '',
    phone: '',
    description: '',
    servicePacks: [],
    services: []
  });

  useEffect(() => {
    setIsLoaded(false);
    ajax('resellerReception', {
      idReception: props.match.params.idReception
    })
      .then(response => {
        if (!isMountedRef.current) return;

        if (response.ok)
          setData(response.data.reception);

        setIsLoaded(true);
      });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const getTotalPriceSL = () => data.servicePacks.reduce((a, b) => a + +b.priceSL, 0) + data.services.reduce((a, b) => a + +b.priceSL, 0);
  const getTotalPrice = () => data.servicePacks.reduce((a, b) => a + +b.price, 0) + data.services.reduce((a, b) => a + +b.price, 0);

  const getVacutainers = () => {
    return [...new Set(
      data.servicePacks.map(servicePack => servicePack.consumables)
      .concat(data.services.map(service => service.consumables))
      .join('|')
      .split('|')
      .filter(item => Boolean(item))
      .sort()
    )]
  };

  return (
    <Container maxWidth='md'>
      <Typography variant='h6'>Detalii recoltare</Typography>
      <Typography variant='subtitle2'>Vizualizare detalii recoltare pentru Sunmed Tulcea</Typography>
      <Divider className={classes.divider} />

      {!isLoaded &&
        <Box display='block' align='center'>
          <CircularProgress />
        </Box>
      }

      {isLoaded &&
        <Fragment>
          <Card className={classes.card}>
            <CardContent>
              <Typography component='div' variant='h6' color='secondary'>
                Recoltare salvata! ID:&nbsp;
                <Typography component='div' variant='h6' color='primary' display='inline'>{data.id}</Typography>
              </Typography>
              <Typography component='div' color='textPrimary'>Marcati {getVacutainers().length === 1 ? 'vacutainerul' : 'vacutainerele'} cu acest numar (ID)</Typography>
              {Boolean(props.user.idPartner) &&
                <Button variant='contained' color='primary' style={{float: 'right'}}
                  onClick={() => window.open(`${props.url.download}?op=resellerComandaAnalize&idResselerReceptions=${data.id}&SID=${props.user.sessid}&variant=live`)}
                >
                  Descarca comanda de analize
                </Button>
              }
            </CardContent>
          </Card>

          <Card className={classes.card}>
            <CardContent>
              <Typography variant='h6'>Necesar vacutainere</Typography>
              <Divider />
              {Boolean(getVacutainers().length)
                ? <List dense>
                    {getVacutainers().map(consumable =>
                      <ListItem key={consumable} disableGutters>
                        <ListItemText
                          primary={consumable}
                        />
                      </ListItem>
                    )}
                  </List>
                : <Typography color='textSecondary'>Nu sunt necesare vacutainere</Typography>
              }
            </CardContent>
          </Card>

          <Grid container spacing={1}>
            <Grid item xs={12} sm={4}>
              <Card className={classes.card}>
                <CardContent className={`${classes.cardContent} ${classes.infoMain}`}>
                  <Typography component='div' align='center'>Venituri</Typography>
                  <Typography variant='subtitle2' align='center'>{getTotalPrice().toFixed(2)} RON</Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={6} sm={4}>
              <Card className={classes.card}>
                <CardContent className={`${classes.cardContent} ${classes.errorMain}`}>
                  <Typography component='div' align='center'>Cheltuieli</Typography>
                  <Typography variant='subtitle2' align='center'>{getTotalPriceSL().toFixed(2)} RON</Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={6} sm={4}>
              <Card className={classes.card}>
                <CardContent className={`${classes.cardContent} ${classes.successLight}`}>
                  <Typography component='div' align='center'>Profit</Typography>
                  <Typography variant='subtitle2' align='center'>{(getTotalPrice() - getTotalPriceSL()).toFixed(2)} RON</Typography>
                </CardContent>
              </Card>
            </Grid>
          </Grid>

          <Card className={classes.card}>
            <CardContent>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <Typography variant='h6'>Detalii pacient</Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <TextField margin='none' required inputProps={{maxLength: 64}}
                    disabled={true}
                    label='Nume'
                    placeholder='Nume'
                    name='surname'
                    value={data.surname}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <TextField margin='none' required inputProps={{maxLength: 64}}
                    disabled={true}
                    label='Prenume'
                    placeholder='Prenume'
                    name='name'
                    value={data.name}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <TextField margin='none' required inputProps={{maxLength: 13}}
                    disabled={true}
                    label='CNP'
                    placeholder='CNP'
                    name='cnp'
                    value={data.cnp}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <TextField margin='none' inputProps={{maxLength: 10}}
                    disabled={true}
                    label='Telefon'
                    placeholder='Telefon'
                    name='phone'
                    value={data.phone}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField margin='none' multiline rows={3} rowsMax={5}
                    disabled={true}
                    label='Observatii'
                    placeholder='Observatii'
                    name='description'
                    value={data.description}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>

          <Card className={classes.card}>
            <CardContent>
              <Typography variant='h6'>Lista servicii</Typography>
              {!Boolean(data.servicePacks.length + data.services.length) &&
                <Warning>Selectati cel putin un pachet sau o analiza!</Warning>
              }

              <Grid container spacing={1}>
                <Grid item xs={12} md={6}>
                  <List>
                    {data.services.map(service =>
                      <ListItem key={service.idServiceSL} dense disableGutters>
                        <ListItemText
                          primary={<Typography component='div' variant='subtitle2' color='textPrimary' noWrap title={service.service}>{service.service}</Typography>}
                          secondary={
                            <Typography component='div' color='textSecondary'>
                              {`${service.category} - rezultate: ${service.worktime === '0' ? 'in aceeasi zi' : service.worktime === '1' ? 'dupa o zi' : `dupa ${service.worktime} zile`}`}
                              <Typography variant='subtitle2' color='primary' display='inline' style={{float: 'right', paddingRight: '16px'}}>{service.price} RON</Typography>
                            </Typography>
                          }
                        />
                      </ListItem>
                    )}
                  </List>
                </Grid>

                <Grid item xs={12} md={6}>
                  <List>
                    {data.servicePacks.map(servicePack =>
                      <ListItem key={servicePack.idServicePackSL} dense disableGutters>
                        <ListItemText
                          primary={<Typography component='div' variant='subtitle2' color='textPrimary' noWrap title={servicePack.servicePack}>{servicePack.servicePack}</Typography>}
                          secondary={
                            <Typography component='div' color='textSecondary'>
                            {`Rezultate: ${servicePack.worktime === '0' ? 'in aceeasi zi' : servicePack.worktime === '1' ? 'dupa o zi' : `dupa ${servicePack.worktime} zile`}`}
                              <Typography variant='subtitle2' color='primary' display='inline' style={{float: 'right', paddingRight: '16px'}}>{servicePack.price} RON</Typography>
                            </Typography>
                          }
                        />
                      </ListItem>
                    )}
                  </List>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Fragment>
      }
    </Container>
  );
}